export default __webpack_public_path__ + "static/media/scf-g-en.4c82ce13.png";